(function communityAndNeighBorhoodHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousCommunityAndNeighBorhoodHandler = global.NewHomeSource.CommunityAndNeighBorhoodHandler;

  /**
   * @constructs NewHomeSource.CommunityAndNeighBorhoodHandler
   */
  function CommunityAndNeighBorhoodHandler() {
  }

  /** 
   *  hideAllSections: function to hide all tabs of the sub menu
   */
  function hideAllSections() {
    const arraySections = document.querySelectorAll('[data-sub-menu-element]');
    arraySections.forEach((section) => {
      section.setAttribute('hidden', '');
    });
  }

  /**
   * turnOnASection: function to show a specific section
   * @param {string} name data parameter with the name of the section
   */
  function showASection(name) {
    const section = document.querySelector('[data-sub-menu-element="' + name + '"]');
    if (section) {
      section.removeAttribute('hidden');
    }
  }

  /**
  * Removes the element focus.
  * @param {any} element
  */
  function removeTabFocus(element) {
      element.classList.remove('bar__item-active', 'nhs-c-button--tap-light-active');
  }

  /**
   * Toggles the active element tab.
   * @param {any} target
   */
  function setActiveTab(target) {
    const selectedItem = target;
    const subMenuItems = document.querySelectorAll('[data-subnav-items] [data-item-list]');

    if (selectedItem) {
      subMenuItems.forEach(removeTabFocus);
        selectedItem.classList.add('bar__item-active', 'nhs-c-button--tap-light-active');
    }
  }

  /**
   *  performClickOnATab: function to control the event click on the tab events
   */
  function performClickOnATab(event) {
    const target = event.target.closest('[data-sub-menu-name]') || event.target;
    if (target) {
      setActiveTab(target);
      hideAllSections();
      showASection(target.dataset.subMenuName);
    }
  }

  /**
   *  setEventsToTabs: function to set the event call back to the tabs
   */
  function setEventsToTabs() {
    const arrayTabs = document.querySelectorAll('[data-sub-menu-name]');
    arrayTabs.forEach((tab) => {
      tab.addEventListener('click', performClickOnATab)
    });
  }

  /**
   *  init: function to start events
   */
  CommunityAndNeighBorhoodHandler.init = function Init() {
    setEventsToTabs();
  };


  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.CommunityAndNeighBorhoodHandler to the previous script.
   */
  CommunityAndNeighBorhoodHandler.noConflict = function noConflict() {
    global.NewHomeSource.CommunityAndNeighBorhoodHandler = previousCommunityAndNeighBorhoodHandler;
    return CommunityAndNeighBorhoodHandler;
  };

  /**
   * @private
   * trackGA4Event: tracks the event when the tools list is expanded.
   * @param {object} event result of the click on the page.
   */
   const trackGA4CollapseEvent = function (event) {
    if (!event || !event.target || !event.target.matches('[data-neighborhood-event]')) {
      return;
    }

    const ga4Event = {
      eventType: 'GA4Event',
      eventName: event.target.dataset.neighborhoodEvent,
      params: {
        click_target: event.target.dataset.neighborhoodClickTarget,
        position: event.target.dataset.neighborhoodPosition,
        click_target1: event.target.dataset.neighborhoodClickTarget1
      }
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: ga4Event
      }
    }));
  };

  global.document.body.addEventListener('click', trackGA4CollapseEvent);

  global.NewHomeSource.CommunityAndNeighBorhoodHandler = CommunityAndNeighBorhoodHandler;

  return CommunityAndNeighBorhoodHandler;
}(window));
